import * as React from 'react';

import { translate } from '~l10n/client';

import { ContactSalesEventAdapter } from '~analytics/adapters/ContactSalesEventAdapter';
import typeform from '~shared/helpers/typeform';

import Constants from '../../../../../shared/Constants';
import CloseX from '../../../../shared/components/buttons/CloseX';
import Anchor from '../../../../shared/components/elements/Anchor';
import Input from '../../../../shared/components/elements/Input';
import Select from '../../../../shared/components/elements/Select';
import HelpTooltip from '../../../../shared/components/tooltips/HelpTooltip';
import SuccessIcon from '../../../../shared/icons/SuccessIcon';

const CouponInput = (license, controller) => {
  let couponInputClass = '';
  let couponButtonClass = 'apply-coupon-button';
  let couponButtonChildren = <>{translate('Apply', true)}</>;

  if (license.couponSuccess) {
    couponInputClass = 'coupon-input-success';
    couponButtonClass = 'apply-coupon-button-success';
    couponButtonChildren = (
      <SuccessIcon color="#ffffff" svgClass="coupon-success-icon" />
    );
  }

  return (
    <div style={{ marginTop: '1em' }}>
      <div className="license-information-item coupon-input">
        {license.couponSuccess && (
          <CloseX
            className="clear-coupon-x"
            color={Constants.CLEAR_INPUT_X}
            onClick={controller.clearCouponClicked}
          />
        )}
        <Input
          className={couponInputClass}
          id="couponName"
          label={translate('Coupon Code', true)}
          maxLength={255}
          onChange={(event: { target: { id: any; value: any } }) =>
            controller.inputChanged(event.target.id, event.target.value)
          }
          onKeyPress={(event: { key: string }) => {
            if (event.key === 'Enter') {
              controller.applyCouponClicked();
            }
          }}
          readOnly={license.couponSuccess}
          status={license.errors.couponName}
          tooltipLocation="above"
          value={license.couponName}
        />{' '}
      </div>
      <div className="license-information-item">
        <button
          className={couponButtonClass}
          disabled={license.couponSuccess}
          id="applyCouponButton"
          onClick={controller.applyCouponClicked}
        >
          {couponButtonChildren}
        </button>
      </div>
    </div>
  );
};
export const LicensePurchase = ({ model, controller, license }) => {
  const [showCouponInput, setShowCouponInput] = React.useState(false);

  const showDiscount = () => {
    if (license.couponSavings) {
      return (
        <div style={{ display: 'flex' }}>
          <span
            style={{
              display: 'flex',
              alignItems: 'center',
              borderRadius: '12px',
              maxWidth: '15em',
              padding: '2px 8px',
              marginTop: '2px',
              color: '#284D2F',
              fontWeight: 'bold',
              backgroundColor: '#C9E9CF',
            }}
          >
            {translate('{0} coupon discount!').format(license.couponSavings)}
          </span>
          <HelpTooltip
            above={true}
            className="discounts-help"
            text={translate('Coupons can‘t be combined with volume discounts')}
          />
        </div>
      );
    } else {
      return null;
    }
  };

  return (
    <div
      className="license-purchase-wrapper"
      style={{ display: 'flex', flexDirection: 'column' }}
    >
      {/*Form*/}
      <div
        className="purchase-section"
        style={{
          display: 'flex',
          flexDirection: 'row',
          marginBottom: '20px',
          background: '#f3f3f3',
          padding: '1.5em',
          paddingTop: 0,
          borderRadius: '8px',
          flexWrap: 'wrap',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            flexBasis: '50%',
            marginRight: '2em',
          }}
        >
          {/*Inputs*/}
          <div
            style={{
              display: 'flex',
              alignItems: 'flex-end',
              marginBottom: '1em',
            }}
          >
            <div className="license-seats" style={{ marginRight: '1em' }}>
              <Input
                id="licenseSeats"
                label={translate('Seats', true)}
                onBlur={controller.seatsBlurred}
                onChange={(event: { target: { id: any; value: any } }) => {
                  controller.seatsChanged(event.target.value);
                  controller.inputChanged(event.target.id, event.target.value);
                }}
                value={license.seats}
              />
            </div>
            <div
              className="license-years"
              style={{ marginRight: '1em', marginBottom: '1px' }}
            >
              <p className="license-label" style={{ marginTop: '20px' }}>
                {translate('Years', true)}
              </p>
              <Select
                label={translate('Years')}
                onSelect={(name: any, value: any) =>
                  controller.yearsChanged(value)
                }
              >
                {{ title: 1, value: 1, selected: license.years === 1 }}
                {{ title: 2, value: 2, selected: license.years === 2 }}
                {{ title: 3, value: 3, selected: license.years === 3 }}
                {{ title: 4, value: 4, selected: license.years === 4 }}
                {{ title: 5, value: 5, selected: license.years === 5 }}
              </Select>
            </div>
          </div>

          {/*Apply seat*/}
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <input
              style={{ marginRight: '0.75rem', width: '18px' }}
              type="checkbox"
              id="applyNow"
              checked={license.applyNow}
              onChange={controller.applyNowChanged}
            />
            <label style={{ marginRight: '0.5em' }} htmlFor="applyNow">
              {translate('Apply one seat to my account')}
            </label>
            <HelpTooltip
              above={true}
              title={translate('Upgrade My Account')}
              text={translate(
                'The number of seats corresponds to the number of teachers that will use this license (students are free). Select this option to use one seat for your account.'
              )}
            />
          </div>

          {/*Coupon*/}
          {showCouponInput ? (
            CouponInput(license, controller)
          ) : (
            <div style={{ marginTop: '1em' }}>
              <Anchor
                className="add-coupon-link"
                label={translate('Add Coupon')}
                onClick={() => setShowCouponInput(true)}
              ></Anchor>
            </div>
          )}
        </div>

        {/*Right Column*/}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div
            className="license-label"
            style={{ marginBottom: '0.5em', marginTop: '20px' }}
          >
            {translate('Price Per Teacher', true)}
          </div>
          {license.pricePerSeatFull !== license.pricePerSeat && (
            <div
              style={{
                fontSize: '24px',
                color: '#ccc',
                textDecoration: 'line-through',
                marginBottom: '0.25em',
              }}
            >
              {license.pricePerSeatPerMonthFullFormatted}
            </div>
          )}
          <div
            style={{
              display: 'flex',
              marginTop: '0.5em',
            }}
          >
            <div
              style={{
                fontSize: '40px',
                lineHeight: '40px',
                fontWeight: 'bold',
                marginRight: '10px',
                marginTop: '-6px',
                marginBottom: '0.5em',
              }}
            >
              {license.pricePerSeatPerMonthFormatted}
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                marginTop: '-6px',
                fontSize: '15px',
              }}
            >
              <span>{translate('per month')}</span>
              <span>(USD)</span>
            </div>
          </div>
          {license.pricePerSeatFull !== license.pricePerSeat ? (
            <div style={{ marginBottom: '0.5em' }} />
          ) : (
            <div style={{ marginBottom: '-0.5em' }} />
          )}
          <div>{showDiscount()}</div>
        </div>
      </div>

      {/*Submit*/}
      <div
        className="purchase-section"
        style={{
          display: 'flex',
          flexDirection: 'row',
          background: '#f3f3f3',
          padding: '20px 20px',
          borderBottomLeftRadius: '8px',
          borderBottomRightRadius: '8px',
          borderTop: '2px solid #ffa100',
          flexWrap: 'wrap',
        }}
      >
        <div
          style={{
            flexBasis: '50%',
            marginRight: '2em',
          }}
        >
          <button
            id="reviewAndPayButton"
            className="action-button action-button-200"
            onClick={controller.reviewAndPayClicked}
          >
            {translate('Review and Pay', true)}
          </button>
        </div>

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <p className="license-label">{translate('Total', true)}</p>
          <span
            style={{ fontWeight: 'bold', fontSize: '2rem', display: 'flex' }}
          >
            {license.totalPriceFormatted}
            <span
              style={{
                fontWeight: 'normal',
                fontSize: '16px',
                marginLeft: '0.5em',
              }}
            >
              (USD)
            </span>
          </span>
        </div>
      </div>

      <div
        style={{
          marginTop: '2em',
          padding: '1em',
          textAlign: 'center',
        }}
      >
        <span style={{ marginRight: '0.5em' }}>
          {translate(
            'Have questions for our sales team or require a quote/purchase order?'
          )}
        </span>
        <Anchor
          className="contact-us-link"
          label={translate('Contact Us.')}
          onClick={() => {
            new ContactSalesEventAdapter({
              form_source: 'typeform',
            }).sendAnalytics();

            window
              .open(
                typeform({
                  seats: license.seats,
                  years: license.years,
                  medium: 'contactus_text',
                  ...model,
                }),
                '_blank'
              )
              .focus();
          }}
        />
      </div>
    </div>
  );
};
